import MailInfo from './MailInfo';
import MailMenu from './MailMenu';
import ActiveMailList from './ActiveMailList';
import MailView from './MailView';
import NewMail from './NewMail';
import { useSelector } from 'react-redux';
import InboxMailList from './InboxMailList';
import SentMailList from './SentMailList';
import FailedMailList from './FailedMailList';

const MailDetails = () => {
    const selectedMenu = useSelector((state:any)=>{return state.emailSlice.selectedMenu})
    const customViewsIframe = document.querySelector('#customviews-container')!;
    customViewsIframe.setAttribute('style', "height: 0; width: 0;");
    return (
        <div className="main-content">
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-12'>
                        <MailInfo />
                    </div>
                </div>
                {/* <div className='row'>
                    <div className='col-12'>
                        <MailInfodetails />
                    </div>
                </div> */}
                <div className='row'>
                    <div className='col-md-2'>
                        <MailMenu />
                    </div>
                    <div className='col-md-3'>
                        {selectedMenu === 'active' && <ActiveMailList />}
                        {selectedMenu === 'inbox' && <InboxMailList />}
                        {selectedMenu === 'sent' && <SentMailList />}
                        {selectedMenu === 'failed' && <FailedMailList /> }
                    </div>
                    <div className='col-md-7'>
                       <MailView />
                    </div>                    
                </div>
                <NewMail />
            </div>
        </div>
    )
}
export default MailDetails;
